import { Icon } from "@iconify/react"
import { Button, Card, Drawer, Flex, Form, Grid, Input, message, Pagination, Table } from "antd"
import { useEffect, useState } from "react";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useTitleStore from "../../store/titleStore";
import { useTableHeight } from "../../hooks/useTableHeight";
import UpdatedByCell from "../../components/UpdatedByCell";
import TableAction from "../../components/TableAction";
import { customerCategoryService } from "../../services/customer-category.service";
import { useForm } from "antd/es/form/Form";


export default function CustomerCategory(){

  const breakpoint = Grid.useBreakpoint()

  const [ form ] = useForm()
  const { setTitle } = useTitleStore();
  const queryClient = useQueryClient();
  const tableHeight = useTableHeight();

  const [drawerOpt, setDrawerOpt] = useState({
    open: false,
    id: null
  })
  
  const [messageApi, contextHolder] = message.useMessage();
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: []
  })

  const { data: informationData , isLoading, isRefetching } = useQuery({
    queryKey: ['customerCategory', dataParams],
    queryFn: () => customerCategoryService.fetchAllWithoutPaginate(dataParams),
    placeholderData: keepPreviousData,
  })

  const { mutate: handleDelete, isPending: deleteLoading } = useMutation({
    mutationFn: (id) => customerCategoryService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries('customerCategory');
      messageApi.success('Data berhasil dihapus');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  const storeMutation = useMutation({
    mutationFn: data => customerCategoryService.store(data),
    onSuccess: () => {
      handleCloseDrawer()
      queryClient.invalidateQueries('customerCategory');
      messageApi.success('Data berhasil ditambah');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  const updateMutation = useMutation({
    mutationFn: data => customerCategoryService.update(data),
    onSuccess: () => {
      handleCloseDrawer()
      queryClient.invalidateQueries('customerCategory');
      messageApi.success('Data berhasil diubah');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  const handleSubmit = val => {
    if(drawerOpt.id) updateMutation.mutate({...val, id: drawerOpt.id})
    else storeMutation.mutate(val)
  }

  useEffect(() => {
    setTitle("Kategori Pelanggan");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const handleUpdate = (record) => {
    form.setFieldsValue(record)
    setDrawerOpt({ open: true, id: record.id })
  }

  const handleCloseDrawer = () => {
    setDrawerOpt({ open: false, id: null })
    form.resetFields()
  }

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      render: (text, record, index) =>  index + 1,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Kategori',
      dataIndex: 'name',
      width: 210,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Tanggal Update',
      width: 210,
      render: val => <UpdatedByCell value={val} />,
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 120,
      fixed: 'right',
      render: record => (
        <TableAction
          onClickEdit={() => handleUpdate(record)}
          handleDelete={() => handleDelete(record.id)}
          deleteLoading={deleteLoading}
        />
      )
    },
  ]

  return (
    <>
      <Card
        styles={{
          body: {
            paddingLeft: 0,
            paddingRight: 0
          }
        }}
      >
        {contextHolder}
        <Flex justify="flex-end" style={{ paddingInline: 24, marginBottom: 24 }} >
          <Button 
            variant="solid" 
            color="primary"  
            icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
            onClick={() => setDrawerOpt({ open: true, id: null })}
          >
            Tambah Kategori
          </Button>
        </Flex>
        <Table
          columns={columns}
          pagination={false}
          size="small"
          loading={isLoading || isRefetching}
          rowKey={'id'}
          scroll={{ y: tableHeight }}
          dataSource={informationData?.data}
        />
        <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={informationData?.pagination?.total}
          showSizeChanger
          pageSizeOptions={['10', '20', '50']}
          current={informationData?.pagination?.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        />
      </Card>
      <Drawer
        open={drawerOpt.open}
        onClose={handleCloseDrawer}
        title={ (drawerOpt.id ? "Ubah" : "Tambah") + " Data"}
        footer={
          <Flex gap={20} >
            <Button block color="primary" variant="outlined" >
              Batal
            </Button>
            <Button onClick={() => form.submit()} block color="primary" variant="solid" >
              Submit
            </Button>
          </Flex>
        }
      >
        <Form
          layout="vertical"
          onFinish={handleSubmit}
          form={form}
        >
          <Form.Item
            name={'name'}
            label="Kategori"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input/>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  )
}